//======> Docementation <======//
registerBlockType("tornado/oloeroo", {
  title: __("Products Single", "tornado"),
  description: __("بلوك", "tornado"),
  icon: "feedback",
  category: "tornado",
  keywords: ["tornado", "section"],
  supports: {
    align: ["full", "wide"],
  },
  attributes: {
    media_video: {
      type: "string",
      selector: ".video",
      default: "https://www.w3schools.com/html/mov_bbb.mp4",
    },
    media: {
      type: "string",
      default: "video",
    },
    head1: {
      type: "string",
      default: "هذا عنوان مؤقت للمحتوي يقع هنا",
    },
    head2: {
      type: "string",
      default: "هذا عنوان مؤقت للمحتوي يقع هنا",
    },
    body1: {
      type: "string",
      default:
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق.",
    },
    body2: {
      type: "string",
      default:
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق.",
    },
    body3: {
      type: "string",
      default:
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق.",
    },
    body4: {
      type: "string",
      default:
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق.",
    },
    qoute: {
      type: "string",
      default:
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق.",
    },
    qouteName: {
      type: "string",
      default: "المصدر:الاسم",
    },
    feats: {
      type: "string",
      default: "3000*1.5*100*150",
    },
  },
  edit({ attributes, setAttributes, className }) {
    const {
      qouteName,
      head1,
      feats,
      head2,
      body1,
      qoute,
      body2,
      body3,
      body4,
      media_video,
    } = attributes;
    const set_media = (media) => {
      setAttributes({ media });
    };
    function onChangeHead1(newHead1) {
      setAttributes({ head1: newHead1 });
    }
    function onChangeHead2(newHead2) {
      setAttributes({ head2: newHead2 });
    }
    function onChangebody1(newBod1y) {
      setAttributes({ body1: newBod1y });
    }
    function onChangebody2(newBod2y) {
      setAttributes({ body2: newBod2y });
    }
    function onChangebody3(newBod3y) {
      setAttributes({ body3: newBod3y });
    }
    function onchangeQoute(newQoute) {
      setAttributes({ qoute: newQoute });
    }
    function OnChangeNameQoute(newName) {
      setAttributes({ qouteName: newName });
    }
    function onChangeFeats(newFeats) {
      setAttributes({ feats: newFeats });
    }
    function onChangebody4(newBod4y) {
      setAttributes({ body4: newBod4y });
    }
    const set_media_video = (openEvent) => {
      return (
        <div className="video-uploader">
          <video
            src={media_video}
            className="round-corner video"
            type="video/mp4"
            controls
          ></video>
          <a href="javascript:void(0);" onClick={openEvent} className="btn">
            تغيير الفيديو
          </a>
        </div>
      );
    };
    return (
      <Panel>
        <InspectorControls style={{ marginBottom: "40px" }}>
          <PanelBody>
            <p> تغيير الفيديو </p>
            <MediaUpload
              render={({ open }) => set_media_video(open)}
              value={media_video}
              onSelect={(media) => {
                setAttributes({ media_video: media.url });
              }}
            />
          </PanelBody>
        </InspectorControls>

        <div class="rich-content">
          <div class="row align-center-y">
            <div class="col-12 col-l-6 mb30">
              <div class="responsive-element hd-size">
                <video
                  src={media_video}
                  className="round-corner"
                  controls
                ></video>
              </div>
            </div>
            <div class="col-12 col-l-6 mb30">
              <RichText
                tagName="h2"
                key="editablle"
                placeholder="عنوان قائمة نقاط كميزة مثلا"
                value={head1}
                onChange={onChangeHead1}
              />
              <RichText
                tagName="p"
                key="editable"
                placeholder="عنوان قائمة نقاط كميزة مثلا"
                value={body1}
                onChange={onChangebody1}
              />
              <RichText
                tagName="p"
                key="editablee"
                placeholder="عنوان قائمة نقاط كميزة مثلا"
                value={body2}
                onChange={onChangebody2}
              />
            </div>
          </div>
          <hr class="mb30" />
          <RichText
            tagName="h3"
            key="editablee"
            placeholder="عنوان قائمة نقاط كميزة مثلا"
            value={head2}
            onChange={onChangeHead2}
          />
          <RichText
            tagName="p"
            key="editablee"
            placeholder="عنوان قائمة نقاط كميزة مثلا"
            value={body3}
            onChange={onChangebody3}
          />
          <RichText
            tagName="blockquote"
            className="blockquote"
            multiline=""
            onChange={onchangeQoute}
            value={qoute}
          />

          <RichText
            tagName="span"
            className="quote-name"
            value={qouteName}
            onChange={OnChangeNameQoute}
          />
          <RichText
            tagName="ul"
            className="half-space squared "
            multiline="li"
            placeholder={__("محتوي على شكل قائمة", "tornado")}
            onChange={onChangeFeats}
            value={feats}
          />

          <RichText
            tagName="p"
            key="editablese"
            placeholder="عنوان قائمة نقاط كميزة مثلا"
            value={body4}
            onChange={onChangebody4}
          />
        </div>
      </Panel>
    );
  },
  save({ attributes, className }) {
    const {
      qouteName,
      feats,
      head1,
      head2,
      body1,
      qoute,
      body2,
      body3,
      body4,
      media_video,
    } = attributes;
    return (
      <div class="rich-content">
        <div class="row align-center-y">
          <div class="col-12 col-l-6 mb30">
            <div class="responsive-element hd-size">
              <video
                src={media_video}
                className="round-corner"
                controls
              ></video>
            </div>
          </div>
          <div class="col-12 col-l-6 mb30">
            <RichText.Content tagName="h2" value={head1} />
            <RichText.Content tagName="p" value={body1} />
            <RichText.Content tagName="p" value={body2} />
          </div>
        </div>
        <hr class="mb30" />
        <RichText.Content tagName="h3" value={head2} />
        <RichText.Content tagName="p" value={body3} />
        <RichText.Content tagName="blockquote" value={qoute} />

        <RichText.Content
          className="quote-name"
          tagName="span"
          value={qouteName}
        />
        <RichText.Content
          tagName="ul"
          className="half-space squared "
          multiline="li"
          value={feats}
        />

        <RichText.Content tagName="p" value={body4} />
      </div>
    );
  },
});
